import React from "react";
import HomeSideNavBar from "../HomeSideNavBar";
import Header from "../Header";
import ApiDataProvider from "../ApiDataContext";
import ScheduledUnlockList from "../../features/scheduledUnlocks/ScheduledUnlockList";

/**
 * Scheduled Group Unlock page shell — same layout as Assets/Command Center.
 * The GPS-lock-only bulk unlock scheduling UI lives in ScheduledUnlockList.
 */
function ScheduledUnlocks() {
  return (
    <ApiDataProvider>
      <div className="container">
        <div className="screen-layout">
          <Header />
          <HomeSideNavBar />
          <main className="flex-1 min-w-0 min-h-0 flex flex-col bg-surface-muted overflow-y-auto">
            <ScheduledUnlockList />
          </main>
        </div>
      </div>
    </ApiDataProvider>
  );
}

export default ScheduledUnlocks;
